type DownloadableFormat = 'md' | 'txt' | 'html'

const sanitizeFilename = (filename: string): string => filename.replace(/[^\w\s-]/g, '').trim()

const triggerBrowserDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

export const downloadBlobAsFile = (blob: Blob, filename: string, extension: string): void => {
  triggerBrowserDownload(blob, `${sanitizeFilename(filename)}.${extension}`)
}

const downloadAsMarkdown = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/markdown' })
  triggerBrowserDownload(blob, `${filename}.md`)
}

const downloadAsText = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/plain' })
  triggerBrowserDownload(blob, `${filename}.txt`)
}

const downloadAsHtml = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/html' })
  triggerBrowserDownload(blob, `${filename}.html`)
}

const FORMAT_HANDLER_MAP: Record<DownloadableFormat, (content: string, filename: string) => void> =
  {
    md: downloadAsMarkdown,
    txt: downloadAsText,
    html: downloadAsHtml,
  }

export const downloadContentAsFile = (
  content: string,
  filename: string,
  format: DownloadableFormat
): void => {
  FORMAT_HANDLER_MAP[format](content, sanitizeFilename(filename))
}
